import type { PuntoEntregaDetail } from '../domain/puntoEntregaModel.ts';
import type { PuntoEntregaFormSnapshot } from '../domain/puntoEntregaFormSnapshot.ts';
import type { PuntosEntregaRepositoryPort } from '../domain/ports/PuntosEntregaRepositoryPort.ts';
import { legacyLugarExistsInComuna } from '../domain/puntoEntregaLugarOrigen.ts';
import { joinDateTime } from '../domain/puntoEntregaFormUtils.ts';

export function buildPuntoEntregaDetailFromFormSnapshot(
  repo: PuntosEntregaRepositoryPort,
  f: PuntoEntregaFormSnapshot,
): PuntoEntregaDetail | null {
  if (!f.entregaId || !f.lugarId || !f.lugarOrigen || !f.fecha.trim()) return null;
  const comuna = repo.listComunas().find((c) => c.id === f.comunaId);
  if (!comuna) return null;

  if (f.lugarOrigen === 'catalogo') {
    const catalog = repo.findPuntosEntregaCatalogoById(f.lugarId);
    if (!catalog || catalog.comunaId !== f.comunaId) return null;
    return {
      id: f.editingId ?? 0,
      publicId: '',
      entregaId: f.entregaId,
      esRemanente: f.esRemanente === 'si',
      lugarId: f.lugarId,
      lugarOrigen: 'catalogo',
      comunaId: comuna.id,
      barrioId: 0,
      fechaHora: joinDateTime(f.fecha, f.hora),
      latitud: f.latitud,
      longitud: f.longitud,
      direccion: catalog.direccion.trim() || f.direccion,
      responsableId: f.responsableId,
      responsableNombre: f.responsableNombre || '',
      informePdf: f.informePdf,
      offlineUploadedAt: null,
      participantes: f.participantesDraft.map((p) => ({ ...p })),
    };
  }

  if (!legacyLugarExistsInComuna(repo, f.comunaId, f.lugarId)) return null;
  return {
    id: f.editingId ?? 0,
    publicId: '',
    entregaId: f.entregaId,
    esRemanente: f.esRemanente === 'si',
    lugarId: f.lugarId,
    lugarOrigen: 'legacy',
    comunaId: comuna.id,
    barrioId: 0,
    fechaHora: joinDateTime(f.fecha, f.hora),
    latitud: f.latitud,
    longitud: f.longitud,
    direccion: f.direccion,
    responsableId: f.responsableId,
    responsableNombre: f.responsableNombre || '',
    informePdf: f.informePdf,
    offlineUploadedAt: null,
    participantes: f.participantesDraft.map((p) => ({ ...p })),
  };
}
